export default {
	exams: 'الامتحانات',
	'go-to-exam': 'الانتقال إلى الامتحان',

	'no-exams': 'لا يوجد امتحانات!',
	'exam-today': 'الامتحان اليوم!',
	'next-exam': 'الامتحان التالي مستحق في',
}